import angular from 'angular';
import treatInformationComponent from './treat-information.component';
import productLabelDownload from './product-label-download/product-label-download.module';

export default angular.module('components.app.product.treatInformation', [
  productLabelDownload
])
  .component('treatInformation', treatInformationComponent)
  .value('EventEmitter', payload => ({ $event: payload }))
  .name;



// WEBPACK FOOTER //
// ./components/app/product/information/treat-information.module.js